import PropTypes from "prop-types";
import React from "react";

import { FormattedDateFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import {
  DATE_OF_BIRTH_MAX_LENGTH,
  DATE_OF_BIRTH_SCHEMA_FIELD_NAME,
} from "./DateOfBirthFormField.schema";

/**
 * DateOfBirthFormField provides support for a FormattedDateFormField component to be used
 * in a Form.
 */

export const DateOfBirthFormField = (props) => {
  const { caption, className, componentProps = {}, defaultValue, disabled, label, name } = props;

  return <FormattedDateFormField {...getDateOfBirthProps()} />;

  function getDateOfBirthProps() {
    return {
      caption: caption ?? i18n("DateOfBirthFormField__CAPTION"),
      componentProps: {
        acceptableCharacters: "0123456789",
        "aria-label": props["aria-label"] ?? i18n("DateOfBirthFormField__ARIA"),
        className,
        defaultValue: getUnformattedDateOfBirth(defaultValue),
        maxLength: DATE_OF_BIRTH_MAX_LENGTH,
        required: true,
        ...componentProps,
      },
      disabled,
      label: label ?? i18n("DateOfBirthFormField__LABEL"),
      name: name ?? DATE_OF_BIRTH_SCHEMA_FIELD_NAME,
    };
  }

  function getUnformattedDateOfBirth(birthday) {
    return birthday?.replaceAll("/", "");
  }
};

export const dateOfBirthFormFieldPropTypes = {
  /** Content to be read by the screen reader. */
  "aria-label": PropTypes.string,

  /** Content below the form field. */
  caption: PropTypes.string,

  /** Class name for positioning the component. */
  className: PropTypes.string,

  /** Additional props to pass to the base form field component. */
  componentProps: PropTypes.object,

  /** Default value for the Date of birth. */
  defaultValue: PropTypes.string,

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Label to identify the form field. */
  label: PropTypes.node,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,
};

DateOfBirthFormField.propTypes = dateOfBirthFormFieldPropTypes;
